import React from 'react';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';

import Tappable from 'react-tappable';

export default React.createClass({
  mixins: [PureRenderMixin],

  render() {
    let { itemNumber, rowIndex } = this.props;
    return (
      <Tappable
        onTap={() =>
          CuesheetCellActions.startEditingItemCell(
            rowIndex,
            EditableCellTypes.ItemNumber,
          )
        }
      >
        <div className="csr-item-number">{itemNumber}</div>
      </Tappable>
    );
  },
});
